import { SvgIcon } from '@mui/material';
import { FC } from 'react';

const Iberia: FC = () => (
  <SvgIcon fontSize="inherit">
    <svg fill="none" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id="linearGradient84"
          x2="1"
          gradientTransform="matrix(38.657,22.318,22.318,-38.657,199.15,332.38)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#a61c22" offset="0" />
          <stop stopColor="#dc1c2e" offset=".5" />
          <stop stopColor="#dc1c2e" offset="1" />
        </linearGradient>
        <linearGradient
          id="linearGradient106"
          x2="1"
          gradientTransform="matrix(25.957,14.986,14.986,-25.957,214.07,351.85)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ed7417" offset="0" />
          <stop stopColor="#facd08" offset=".85" />
          <stop stopColor="#facd08" offset="1" />
        </linearGradient>
      </defs>
      <g transform="matrix(.25538 0 0 -.25538 -130.36 128.98)">
        <g transform="matrix(2.2134,0,0,2.2134,72.763,-317.05)">
          <path
            // eslint-disable-next-line max-len
            d="m205.35 342.15-7.487-7.557v-1e-3c25.989 0 32.116 6.11 35.691 14.427l3.002 7.829c-8.756-0.252-21.969-5.413-31.206-14.698"
            fill="url(#linearGradient84)"
          />
          <path
            // eslint-disable-next-line max-len
            d="m222.81 359.83-8.424-8.533c7.998 5.745 15.974 9.211 23.92 10.106l1.937 5.052c-11.763 0-13.365-2.572-17.433-6.625"
            fill="url(#linearGradient106)"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default Iberia;
